/**
 * Tipografia padrão do produto — Inter (UI/CRM: legível, neutra, boa em tabelas e densidade alta).
 */
export const APP_FONT_FAMILY = [
  '"Inter"',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
].join(', ');

export const APP_MONO_FONT_FAMILY = [
  '"Roboto Mono"',
  '"JetBrains Mono"',
  'ui-monospace',
  'SFMono-Regular',
  'Menlo',
  'Monaco',
  'Consolas',
  'monospace',
].join(', ');

export const appTypography = {
  fontFamily: APP_FONT_FAMILY,
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  h1: {
    fontSize: '1.75rem',
    fontWeight: 600,
    letterSpacing: '-0.025em',
    lineHeight: 1.25,
  },
  h2: {
    fontSize: '1.375rem',
    fontWeight: 600,
    letterSpacing: '-0.02em',
    lineHeight: 1.3,
  },
  h3: {
    fontSize: '1.125rem',
    fontWeight: 600,
    letterSpacing: '-0.015em',
    lineHeight: 1.35,
  },
  h4: {
    fontSize: '1rem',
    fontWeight: 600,
    letterSpacing: '-0.01em',
    lineHeight: 1.4,
  },
  h5: {
    fontSize: '0.9375rem',
    fontWeight: 600,
    letterSpacing: '-0.008em',
    lineHeight: 1.4,
  },
  h6: {
    fontSize: '0.875rem',
    fontWeight: 600,
    letterSpacing: '0',
    lineHeight: 1.45,
  },
  subtitle1: {
    fontSize: '0.9375rem',
    fontWeight: 500,
    letterSpacing: '-0.006em',
    lineHeight: 1.45,
  },
  subtitle2: {
    fontSize: '0.8125rem',
    fontWeight: 600,
    letterSpacing: '0.02em',
    lineHeight: 1.4,
    textTransform: 'uppercase',
  },
  body1: {
    fontSize: '0.9375rem',
    fontWeight: 400,
    letterSpacing: '-0.006em',
    lineHeight: 1.55,
  },
  body2: {
    fontSize: '0.8125rem',
    fontWeight: 400,
    letterSpacing: '-0.003em',
    lineHeight: 1.5,
  },
  button: {
    fontSize: '0.875rem',
    fontWeight: 500,
    letterSpacing: '-0.01em',
    textTransform: 'none',
  },
  caption: {
    fontSize: '0.75rem',
    fontWeight: 400,
    letterSpacing: '0.01em',
    lineHeight: 1.4,
  },
  overline: {
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    lineHeight: 1.4,
  },
};

export const appCssBaselineGlobals = {
  html: {
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    textRendering: 'optimizeLegibility',
  },
  body: {
    fontFamily: APP_FONT_FAMILY,
    fontFeatureSettings: '"cv11", "ss01"',
  },
  '#root': {
    fontFamily: APP_FONT_FAMILY,
  },
  'button, input, textarea, select': {
    fontFamily: 'inherit',
  },
};
